export const humanReadable = (number: number) => {
    if (number < 1_000) return number.toString();

    if (number < 1_000_000) return `${(number / 1_000).toFixed()}K`;

    if (number < 1_000_000_000) return `${(number / 1_000_000).toFixed()}M`;

    if (number < 1_000_000_000_000) return `${(number / 1_000_000_000).toFixed()}B`;

    return 'A lot';
};

/**
 * Quantizes a number by a given step
 *
 * E.g.
 * quantize(6, 5) === 5
 * quantize(8, 5) === 10
 *
 * Credit: https://github.com/jamesplease/quantize-number/blob/master/src/quantize-number.js (MIT License)
 */
export const quantizeNumber = (value: number, quantum?: number) => {
    if (!quantum) return 0;

    const remainder = value % quantum;
    const sign = Math.sign(value);
    const mod = remainder > quantum / 2 ? quantum : 0;

    return value - remainder + sign * mod;
};
